import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';

import { updateFoodCategoriesFailure, updateFoodCategoriesRequest, updateFoodCategoriesSuccess } from "../../slices/Content/UpdateFoodCategoriesSlice"


export const UpdateFoodCategoryAPI = (id,data) => {
    return async (dispatch) => {
        try {
            dispatch(updateFoodCategoriesRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "PUT",
                url: `${endpoints.updateFoodCategories}/${id}`,
                data: data,
            })
            return dispatch(updateFoodCategoriesSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(updateFoodCategoriesFailure(_error));
        }
    };
};
